import StateType from './state.type';

export default {
  loading: false,
  loadingRemove: false,
  account: {
    address: {},
  },
} as StateType;
